import PracticeDataServiceClient from '@/services/PracticeDataServiceClient'
import * as types from '@/store/practice/mutation-types'

export const getPracticeInfo = ({ commit }, practiceUuid) => {
  const client = new PracticeDataServiceClient(practiceUuid)

  return client.getPractice(practiceUuid)
    .then((response) => {
      commit(types.SET_PRACTICE_INFO, response.data)
    })
    .catch((error) => {
      commit(types.SET_PRACTICE_INFO, {})
      throw error.response.data.message
    })
}
